module.exports = __webpack_public_path__ + "static/media/bookmark (2).1e8e05db.svg";